<div class="header" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
    <img width="40px" src={{iconUrl}} i18n-alt alt="Gasolinera">
    <span class="title" i18n> Gasolinera <span *ngIf="company!=='(SIN RÓTULO)'">{{ company }}</span></span>
</div>


<div class="content">
    <div >
        <span class="detail-name" i18n>Dirección:</span> {{address}}
    </div>
    
    <div *ngIf="timetable">
        <span class="detail-name" i18n>Horario:</span> {{timetable}}
    </div>
    
    <div>
        <span class="detail-name" i18n>Precio de los carburantes:</span>
        <ul>
            <li *ngFor="let carburante of prices">
                {{carburante.title}}: {{carburante.value}} €/l
            </li>
        </ul>
    </div>
</div>

<div class="source">
    <div class="last-update" i18n>
        Los precios indicados hacen referencia al <b>{{pricesDate}}</b>
    </div>
    <b i18n>Fuente:</b> {{source}}
</div>